import { useSelector } from "react-redux";
import {
  selectProductLoadingStatus,
  selectProducts,
} from "../features/product/productSlice";
import { Link } from "react-router-dom";
import { indiaCurrency } from "../constants/services";

export default function ProductList() {
  const products = useSelector(selectProducts);
  const productLoadingStatus = useSelector(selectProductLoadingStatus);
  return (
    <div className="bg-white  ">
      {productLoadingStatus === "loading" ? (
        <div className="w-full my-4 flex justify-center">
          <div
            className="inline-block  h-8 w-8 animate-spin rounded-full  border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          >
            <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
        </div>
      ) : null}
      {products ? (
        <div className="mx-auto max-w-2xl px-4 py-1 sm:px-6 sm:py-4 lg:max-w-7xl lg:px-8">
          <h2 className="sr-only">Products</h2>

          <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 xl:gap-x-8">
            {products.map((product, index) => (
              <Link to={`/productOverview/${product.id}`}>
                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                  <img
                    src={product.images[0]}
                    alt={product.title}
                    className="h-full w-full object-cover object-center group-hover:opacity-75"
                  />
                </div>
                <h3 className="mt-4 text-sm text-gray-700 font-semibold ">
                  {product.title}
                </h3>
                <h3 className="mt-2 text-sm text-gray-700  ">
                  {product.detail && product.detail.slice(0, 25) + "..."}
                </h3>
                <h3 className="mt-2 text-sm text-gray-700  ">
                  Color {product.colors && product.colors.length}
                </h3>

                <p className="mt-2 text-sm text-gray-700 font-semibold ">
                  MRP : {indiaCurrency}
                  {product.discountPrice}
                </p>
                <p className="mt-2 text-sm text-gray-700 font-semibold line-through ">
                  MRP : {indiaCurrency}
                  {product.price}
                </p>
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <div className="w-full my-4 flex justify-center">
          <div
            className="inline-block  h-8 w-8 animate-spin rounded-full  border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          >
            <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
